import { mobileSlotOpenerDragElementSrc38Evid1603 } from '@wix/bi-logger-editor-data/v2';
import { biLogger, array } from '#packages/util';

import type { CompRef } from 'types/documentServices';
import type { EditorAPI } from '#packages/editorAPI';

export const reportSlotOpenedBI = (
  editorAPI: EditorAPI,
  compRef: CompRef | CompRef[],
  origin: 'drag' | 'add_panel',
) => {
  const nonPageAncestors = editorAPI.components
    .getAncestors(array.asSingle(compRef))
    .filter((comp) => !editorAPI.components.is.page(comp));

  biLogger.report(
    //@ts-expect-error
    mobileSlotOpenerDragElementSrc38Evid1603({
      origin,
      component_type: array.isMultiselect(compRef)
        ? 'multiselect'
        : editorAPI.components.getType(array.asSingle(compRef)),
      component_id: array.isMultiselect(compRef)
        ? null
        : array.asSingle(compRef).id,
      parent_component_type: editorAPI.components.getType(nonPageAncestors[0]),
      parent_component_id: nonPageAncestors[0].id,
      non_page_top_parent_component_type: editorAPI.components.getType(
        nonPageAncestors[nonPageAncestors.length - 1],
      ),
      non_page_top_parent_component_id:
        nonPageAncestors[nonPageAncestors.length - 1].id,
      editor_working_mode: editorAPI.isMobileEditor() ? 'mobile' : 'desktop',
    }),
  );
};
